"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _SecretRequirements = _interopRequireWildcard(require("../auth/SecretRequirements"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// const txtFieldState = {
//   value: "",
//   valid: true,
//   typeMismatch: false,
//   errMsg: "" // this is where our error message gets across
// };

const errorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger"
}, msg);
class PasswordChangeForm extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      currentPassword: undefined,
      secret: '',
      confirmPassword: undefined,
      currentPasswordError: null,
      secretError: null,
      confirmPasswordError: null,
      Strength: '',
      StrengthValue: 0,
      isOpen: false
    });
    _defineProperty(this, "enableSubmit", (currentPasswordArg, newPasswordArg, confirmPasswordArg, StrengthArg) => {
      let {
        currentPassword,
        secret: newPassword,
        confirmPassword,
        Strength
      } = this.state;
      const {
        handleValidation
      } = this.props;
      if (currentPasswordArg) {
        currentPassword = currentPasswordArg;
      }
      if (newPasswordArg) {
        newPassword = newPasswordArg;
      }
      if (confirmPasswordArg) {
        confirmPassword = confirmPasswordArg;
      }
      if (StrengthArg) {
        Strength = StrengthArg;
      }
      if (newPassword && newPassword.length > 0 && confirmPassword && confirmPassword.length > 0 && Strength !== 'Weak' && newPassword === confirmPassword && currentPassword && currentPassword.length > 0 && currentPassword !== newPassword && !(0, _SecretRequirements.getValidationMessage)(newPassword, 10, 24)) {
        handleValidation(true);
      } else {
        handleValidation(false);
      }
    });
    _defineProperty(this, "measureStrength", secret => {
      let score = 0;
      let Strength;
      let StrengthValue = 0;
      const regexPositive = ['[A-Z]', '[a-z]', '[0-9]', '[.*@_-]'];
      regexPositive.forEach(regex => {
        if (new RegExp(regex).test(secret)) {
          score += 1;
        }
      });
      if (score === 4 && secret.length >= 10) {
        score += 1;
      }
      if (secret === '') {
        this.setState({
          Strength: '',
          StrengthValue: '0'
        });
        return;
      }
      switch (score) {
        case 0:
        case 1:
        case 2:
        case 3:
          Strength = 'Weak';
          StrengthValue = '15';
          break;
        case 4:
          Strength = 'Good';
          StrengthValue = '60';
          break;
        case 5:
          Strength = 'Strong';
          StrengthValue = '100';
          break;
        default:
          Strength = '';
          StrengthValue = '0';
      }
      this.setState({
        Strength,
        StrengthValue
      });
      this.enableSubmit(null, null, null, Strength);
    });
    _defineProperty(this, "handleCurrentPasswordChange", e => {
      const currentPassword = e.target.value;
      e.persist();
      this.enableSubmit(currentPassword, null, null, null);
      this.setState({
        currentPassword
      }, () => {
        this.onCurrentPasswordChange();
      });
    });
    _defineProperty(this, "handleCurrentPasswordBlur", e => {
      const currentPassword = e.target.value;
      e.persist();
      this.enableSubmit(currentPassword, null, null, null);
      this.setState({
        currentPassword
      }, () => {
        this.onCurrentPasswordChange();
      });
    });
    _defineProperty(this, "handlePasswordChange", e => {
      const secret = e.target.value;
      e.persist();
      this.enableSubmit(null, secret, null, null);
      this.setState({
        secret
      }, () => {
        this.onPasswordChange();
      });
    });
    _defineProperty(this, "handlePasswordBlur", e => {
      const secret = e.target.value;
      this.enableSubmit(null, secret, null, null);
      e.persist();
      this.setState({
        secret
      });
    });
    _defineProperty(this, "handleConfirmPasswordChange", e => {
      const confirmPassword = e.target.value;
      e.persist();
      this.setState({
        confirmPassword
      }, () => {
        this.onConfirmPasswordChange();
      });
      this.enableSubmit(null, null, confirmPassword, null);
    });
    _defineProperty(this, "handleConfirmPasswordBlur", e => {
      const confirmPassword = e.target.value;
      this.setState({
        confirmPassword
      }, () => {
        this.onConfirmPasswordBlur();
      });
      this.enableSubmit(null, null, confirmPassword, null);
    });
    _defineProperty(this, "toggleOpen", () => {
      const {
        isOpen
      } = this.state;
      this.setState({
        isOpen: !isOpen
      });
    });
  }
  onValidations() {
    this.onCurrentPasswordChange();
    this.onPasswordChange();
    this.onPasswordBlur();
    this.onConfirmPasswordChange();
    this.onConfirmPasswordBlur();
    const {
      secret
    } = this.state;
    const valMessage = (0, _SecretRequirements.getValidationMessage)(secret, 10, 24);
    if (valMessage) {
      this.setState({
        secretError: errorMessage(valMessage)
      });
    }
  }
  onSubmit() {
    this.onValidations();
  }
  onCurrentPasswordChange() {
    const {
      currentPassword
    } = this.state;
    if (!currentPassword || currentPassword.length === 0) {
      this.setState({
        currentPasswordError: errorMessage('This field is required for submission')
      });
    } else {
      this.setState({
        currentPasswordError: null
      });
    }
  }
  onPasswordChange() {
    const {
      secret
    } = this.state;
    if (secret.length === 0) {
      this.setState({
        secretError: errorMessage('This field is required for submission')
      });
    } else {
      this.setState({
        secretError: null
      });
    }
    this.onPasswordBlur();
  }
  onPasswordBlur() {
    const {
      secret,
      currentPassword
    } = this.state;
    if (secret.length === 0) {
      this.setState({
        secretError: errorMessage('This field is required for submission')
      });
    } else if (secret.length > 0 && secret === currentPassword) {
      this.setState({
        secretError: errorMessage('New password must not match your current password.')
      });
    } else {
      const valMessage = (0, _SecretRequirements.getValidationMessage)(secret, 10, 24);
      this.setState({
        confirmPasswordError: null,
        secretError: valMessage
      });
    }
    this.measureStrength(secret);
  }
  onConfirmPasswordChange() {
    const {
      confirmPassword
    } = this.state;
    if (!confirmPassword || confirmPassword.length === 0) {
      this.setState({
        confirmPasswordError: errorMessage('This field is required for submission')
      });
    } else {
      this.setState({
        confirmPasswordError: null
      });
    }
  }
  onConfirmPasswordBlur() {
    const {
      secret,
      confirmPassword
    } = this.state;
    if (!confirmPassword || confirmPassword.length === 0) {
      this.setState({
        confirmPasswordError: errorMessage('This field is required for submission')
      });
    } else if (secret.length > 0 && secret !== confirmPassword) {
      this.setState({
        confirmPasswordError: errorMessage('Confirm password must match your new password.')
      });
    } else {
      this.setState({
        confirmPasswordError: null
      });
    }
  }
  render() {
    const {
      currentPasswordError,
      currentPassword,
      secretError,
      secret,
      confirmPasswordError,
      confirmPassword,
      Strength,
      StrengthValue,
      isOpen
    } = this.state;
    const {
      isLoading,
      isError
    } = this.props;
    let StrengthColor = '';
    if (Strength === 'Weak') {
      StrengthColor = 'is-danger';
    }
    if (Strength === 'Good') {
      StrengthColor = 'is-warning';
    }
    if (Strength === 'Strong') {
      StrengthColor = 'is-success';
    }
    if (isError) return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: '382px',
        width: '584px'
      },
      className: "is-full-width has-text-centered"
    }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", null, "We are unable to process your request. Please try again later. "));
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, isLoading ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: '462px',
        width: '584px',
        position: 'absolute',
        zIndex: '2'
      },
      className: "is-full-width has-text-centered"
    }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Spinner, null)) : '', /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this.onSubmit,
      noValidate: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "password-change-form"
    }, /*#__PURE__*/_react.default.createElement(_core.Row, null, /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "current-password",
      className: "label"
    }, "Current Password", /*#__PURE__*/_react.default.createElement("span", null, " *"), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${currentPasswordError && 'is-danger'}`,
      type: "password",
      placeholder: "Enter current password",
      id: "current-password",
      name: "current-password",
      size: "15",
      onChange: this.handleCurrentPasswordChange,
      onBlur: this.handleCurrentPasswordBlur,
      value: currentPassword || '',
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock")))), currentPasswordError), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "password",
      className: "label"
    }, "New Password", /*#__PURE__*/_react.default.createElement("span", null, " *"), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${secretError && 'is-danger'}`,
      type: "password",
      placeholder: "Enter new password",
      id: "password",
      name: "password",
      size: "15",
      onChange: this.handlePasswordChange,
      onBlur: this.handlePasswordBlur,
      value: secret,
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock")))), secretError), /*#__PURE__*/_react.default.createElement("div", {
      className: "columns"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-8"
    }, /*#__PURE__*/_react.default.createElement("progress", {
      className: `progress ${StrengthColor}`,
      value: StrengthValue,
      max: "100",
      style: {
        display: 'inline-block'
      }
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-mobile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column"
    }, /*#__PURE__*/_react.default.createElement("a", {
      onClick: this.toggleOpen
    }, /*#__PURE__*/_react.default.createElement("span", {
      class: "icon-text"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "pb-2"
    }, "Password Requirements"), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `table-cell--actionable${isOpen ? ' is-open' : ''}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "table-cell--actionable-container"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons has-text-link "
    }, "info "), /*#__PURE__*/_react.default.createElement("div", {
      className: "popover-menu content-left",
      style: {
        width: '300px',
        right: 'unset',
        left: '-125%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "triangle"
    }), /*#__PURE__*/_react.default.createElement(_SecretRequirements.default, {
      name: "password-hand",
      secret: secret,
      minLength: 10,
      maxLength: 24,
      key: secret
    }))))))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "confirm-password",
      className: "label"
    }, "Confirm Password", /*#__PURE__*/_react.default.createElement("span", null, " *"), /*#__PURE__*/_react.default.createElement("div", {
      className: "control has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${confirmPasswordError && 'is-danger'}`,
      type: "password",
      placeholder: "Confirm new password",
      id: "confirm-password",
      name: "confirm-password",
      size: "15",
      onChange: this.handleConfirmPasswordChange,
      onBlur: this.handleConfirmPasswordBlur,
      value: confirmPassword || '',
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock")))), confirmPasswordError), /*#__PURE__*/_react.default.createElement("div", {
      className: "columns",
      style: {
        height: '90px'
      }
    }, "\xA0"))))));
  }
}
PasswordChangeForm.propTypes = {
  cancelUrl: _propTypes.default.string,
  isLoading: _propTypes.default.any,
  isError: _propTypes.default.any,
  handleValidation: _propTypes.default.any
};
var _default = exports.default = PasswordChangeForm;
//# sourceMappingURL=PasswordChangeForm.js.map